import { useNavigate } from 'react-router-dom';

import { PageTemplate } from '@_widgets/common';

import { CHARACTER_IMGS } from '@_shared/imgs';
import { Button } from '@_shared/ui/Button';
import { Typography } from '@_shared/ui/Typography';

import * as S from './LeaveDonePage.style';

export function LeaveDonePage() {
	const navigate = useNavigate();
	return (
		<PageTemplate
			header={false}
			nav={
				<S.BottomButtonContainer>
					<Button
						bgColor="orange-primary"
						fullWidth
						height="50px"
						onClick={() => {
							navigate('/login');
						}}
					>
						<Typography type="title-large" color="white-primary">
							로그인 화면으로 돌아가기
						</Typography>
					</Button>
				</S.BottomButtonContainer>
			}
		>
			<S.Container>
				<Typography type="headline-small" color="font-primary">
					탈퇴가 완료되었습니다.
				</Typography>
				<img src={CHARACTER_IMGS.SLEEPING_CHARACTER_IMG} alt="sleeping character 1" />
				<Typography type="body-large" color="font-tertiary" textAlign="center">
					그동안 이용해주셔서 감사합니다.
					<br />
					회원가입을 통해
					<br />
					언제든지 다시 시작할 수 있어요!
				</Typography>
			</S.Container>
		</PageTemplate>
	);
}
